export default "__VITE_ASSET__wAPAFyAu__"